module.exports = __webpack_public_path__ + "static/bearbathmain-45d971822edcd7f69bc9ae0c54bd9196.png";